export default __webpack_public_path__ + "static/media/implied-2.383acaf6.jpg";